import { useSetEnvironmentAttributes } from '@application/Interfaces/Hooks/useGrowthBook/useSetEnvironmentAttributes/useSetEnvironmentAttributes'
import { useSetGaUserIdAttributes } from '@application/Interfaces/Hooks/useGrowthBook/useSetGaUserIdAttributes/useSetGaUserIdAttributes'
import { useSetOrganizationAttributes } from '@application/Interfaces/Hooks/useGrowthBook/useSetOrganizationAttributes/useSetOrganizationAttributes'
import { useSetVisitorUuidAttributes } from '@application/Interfaces/Hooks/useGrowthBook/useSetVisitorUuidAttributes/useSetVisitorUuidAttributes'

export const useSetGrowthBookAttributes = (): null => {
    useSetVisitorUuidAttributes()

    // TODO when we implement country ip API then need to set attrbite same as popeye
    // useSetCountryAttributes()

    useSetOrganizationAttributes()

    useSetGaUserIdAttributes()

    // TODO need to implement logged attributes
    // useSetLoggedInAttributes()

    useSetEnvironmentAttributes()

    return null
}
